export const TrainerStatisticsMockData = {
    name: "SEAN TARRY",
    career: "30:4-2-6",
    previousRaces: [
        {
            date: '21.03.18',
            course: 'F',
            referenceAndGoing: '328G',
            race: 'JP-F',
            distance: '1200m',
            horse: {
                name: 'BOLD VIKING',
                horseId: ''
            },
            trainer: {
                name: 'Mjoka M',
                trainerId: ''
            },
            meritRating: '63',
            weight: '51,6kg',
            draw: '3/12',
            position: {
                value: '1',
                raceId: ''
            },
            lengthsBehind: '1,25',
            time: '102.94',
            adjustedTime: '104.67',
            openingPrice: {
                numerator: '8',
                denominator: '1'
            },
            startingPrice: {
                numerator: '13',
                denominator: '1'
            }
        },
        {
            date: '21.03.18',
            course: 'F',
            referenceAndGoing: '328G',
            race: 'JP-F',
            distance: '1200m',
            horse: {
                name: 'BOLD VIKING',
                horseId: ''
            },
            trainer: {
                name: 'Mjoka M',
                trainerId: ''
            },
            meritRating: '63',
            weight: '51,6kg',
            draw: '3/12',
            position: {
                value: '1',
                raceId: ''
            },
            lengthsBehind: '1,25',
            time: '102.94',
            adjustedTime: '104.67',
            openingPrice: {
                numerator: '8',
                denominator: '1'
            },
            startingPrice: {
                numerator: '13',
                denominator: '1'
            }
        },
        {
            date: '21.03.18',
            course: 'F',
            referenceAndGoing: '328G',
            race: 'JP-F',
            distance: '1200m',
            horse: {
                name: 'BOLD VIKING',
                horseId: ''
            },
            trainer: {
                name: 'Mjoka M',
                trainerId: ''
            },
            meritRating: '63',
            weight: '51,6kg',
            draw: '3/12',
            position: {
                value: '1',
                raceId: ''
            },
            lengthsBehind: '1,25',
            time: '102.94',
            adjustedTime: '104.67',
            openingPrice: {
                numerator: '8',
                denominator: '1'
            },
            startingPrice: {
                numerator: '13',
                denominator: '1'
            }
        },
        {
            date: '21.03.18',
            course: 'F',
            referenceAndGoing: '328G',
            race: 'JP-F',
            distance: '1200m',
            horse: {
                name: 'BOLD VIKING',
                horseId: ''
            },
            trainer: {
                name: 'Mjoka M',
                trainerId: ''
            },
            meritRating: '63',
            weight: '51,6kg',
            draw: '3/12',
            position: {
                value: '1',
                raceId: ''
            },
            lengthsBehind: '1,25',
            time: '102.94',
            adjustedTime: '104.67',
            openingPrice: {
                numerator: '8',
                denominator: '1'
            },
            startingPrice: {
                numerator: '13',
                denominator: '1'
            }
        },
        {
            date: '21.03.18',
            course: 'F',
            referenceAndGoing: '328G',
            race: 'JP-F',
            distance: '1200m',
            horse: {
                name: 'BOLD VIKING',
                horseId: ''
            },
            trainer: {
                name: 'Mjoka M',
                trainerId: ''
            },
            meritRating: '63',
            weight: '51,6kg',
            draw: '3/12',
            position: {
                value: '1',
                raceId: ''
            },
            lengthsBehind: '1,25',
            time: '102.94',
            adjustedTime: '104.67',
            openingPrice: {
                numerator: '8',
                denominator: '1'
            },
            startingPrice: {
                numerator: '13',
                denominator: '1'
            }
        },
        {
            date: '21.03.18',
            course: 'F',
            referenceAndGoing: '328G',
            race: 'JP-F',
            distance: '1200m',
            horse: {
                name: 'BOLD VIKING',
                horseId: ''
            },
            trainer: {
                name: 'Mjoka M',
                trainerId: ''
            },
            meritRating: '63',
            weight: '51,6kg',
            draw: '3/12',
            position: {
                value: '1',
                raceId: ''
            },
            lengthsBehind: '1,25',
            time: '102.94',
            adjustedTime: '104.67',
            openingPrice: {
                numerator: '8',
                denominator: '1'
            },
            startingPrice: {
                numerator: '13',
                denominator: '1'
            }
        },
        {
            date: '21.03.18',
            course: 'F',
            referenceAndGoing: '328G',
            race: 'JP-F',
            distance: '1200m',
            horse: {
                name: 'BOLD VIKING',
                horseId: ''
            },
            trainer: {
                name: 'Mjoka M',
                trainerId: ''
            },
            meritRating: '63',
            weight: '51,6kg',
            draw: '3/12',
            position: {
                value: '1',
                raceId: ''
            },
            lengthsBehind: '1,25',
            time: '102.94',
            adjustedTime: '104.67',
            openingPrice: {
                numerator: '8',
                denominator: '1'
            },
            startingPrice: {
                numerator: '13',
                denominator: '1'
            }
        },
        {
            date: '21.03.18',
            course: 'F',
            referenceAndGoing: '328G',
            race: 'JP-F',
            distance: '1200m',
            horse: {
                name: 'BOLD VIKING',
                horseId: ''
            },
            trainer: {
                name: 'Mjoka M',
                trainerId: ''
            },
            meritRating: '63',
            weight: '51,6kg',
            draw: '3/12',
            position: {
                value: '1',
                raceId: ''
            },
            lengthsBehind: '1,25',
            time: '102.94',
            adjustedTime: '104.67',
            openingPrice: {
                numerator: '8',
                denominator: '1'
            },
            startingPrice: {
                numerator: '13',
                denominator: '1'
            }
        }
    ]
};